// extracted by mini-css-extract-plugin
export default {"ratio":"Square_ratio__Yzztx","square":"Square_square__TnXTC","threeQuarters":"Square_threeQuarters__M+9Kt","oneFifty":"Square_oneFifty__5v7KQ"};